'use strict';
define(['app'], function (app) {
    app.service('TrafficInsightsService', TrafficInsightsService);
    TrafficInsightsService.$inject = ['$q', 'API', '__env'];

    function TrafficInsightsService($q, API, __env) {
        var apiPath = __env.apiGateway + '/api/v2/traffic-insights';

        function getProject(projectId, locationCode, years) {
            var deferred = $q.defer();
            var params = [];
            if (locationCode) params.push('location_code=' + encodeURIComponent(locationCode));
            if (years) params.push('years=' + encodeURIComponent(years));
            var query = params.length ? '?' + params.join('&') : '';
            API.get(apiPath + '/projects/' + encodeURIComponent(projectId) + query, {}, true)
                .then(function (response) {
                    var data = response && response.data !== undefined ? response.data : response;
                    if (!data || data.error) {
                        deferred.reject(new Error('Invalid traffic insights response'));
                        return;
                    }
                    deferred.resolve(data);
                })
                .catch(function (error) {
                    deferred.reject(error);
                });
            return deferred.promise;
        }

        return {getProject: getProject};
    }
});
